import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { addSpaceEvery4, decimal, GetStatus, money, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useCallApi } from "api/apiHooks"
import { useModal } from "utils/context/ModalContext"
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards"
import { CustomerCardService } from "services/CustomerCardService/CustomerCardService"

export default function CustomerCardForm(){
    const navigate = useNavigate()
    const debounceRef = useRef(null)
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBankList, fetchCardVendorList, fetchDeleteCustomerCard, fetchCustomerList  } = useCallApi()
    const { fetchCreateCustomerCard, fetchUpdateCustomerCard, fetchCustomerCardById } = CustomerCardService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerCardId = queryString.get("customerCardId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [cardVendorId, setCardVendorId] = useState(EmptyString)
    const [cardVendorOptions, setCardVendorOptions] = useState([])
    const [customerId, setCustomerId] = useState(EmptyString)
    const [customerOptions, setCustomerOptions] = useState([])
    const [expiredMonth, setExpiredMonth] = useState(EmptyString)
    const [expiredYear, setExpiredYear] = useState(EmptyString)
    const [vcc, setVcc] = useState(EmptyString)
    const [mdr, setMdr] = useState(EmptyString)
    const [mdrQris, setMdrQris] = useState(EmptyString)
    const [mdrPl, setMdrPl] = useState(EmptyString)
    const [mdrPlQris, setMdrPlQris] = useState(EmptyString)
    const [billingDate, setBillingDate] = useState(EmptyString)
    const [dueDate, setDueDate] = useState(EmptyString)
    const [cardLimit, setCardLimit] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorCardNumber, setErrorCardNumber] = useState(false)
    const [errorBankId, setErrorBankId] = useState(false)
    const [errorCardVendorId, setErrorCardVendorId] = useState(false)
    const [errorCustomerId, setErrorCustomerId] = useState(false)
    const [errorMdr, setErrorMdr] = useState(false)
    
    const cardNumberChange = (e) => { setCardNumber(addSpaceEvery4(removeNonNumeric(e.target.value))) }
    const bankIdChange = (e) => { setBankId(e.value) }
    const cardVendorIdChange = (e) => { setCardVendorId(e.value) }
    const customerIdChange = (e) => { setCustomerId(e) }
    const expiredMonthChange = (e) => { setExpiredMonth(removeNonNumeric(e.target.value)) }
    const expiredYearChange = (e) => { setExpiredYear(removeNonNumeric(e.target.value)) }
    const vccChange = (e) => { setVcc(removeNonNumeric(e.target.value)) }
    const mdrChange = (e) => { setMdr(decimal(e.target.value)) }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    if (formType === FormTypeAdd){
                        const res = await fetchCreateCustomerCard(
                            customerId.value,
                            cardNumber.replace(/\s+/g, ""),
                            bankId,
                            cardVendorId,
                            expiredMonth,
                            expiredYear,
                            vcc,
                            mdr,
                            mdrQris,
                            mdrPl,
                            mdrPlQris,
                            dueDate,
                            billingDate,
                            cardLimit.replaceAll(',', '')
                        )
                        if (!res) return
                    }else{
                        const res = await fetchUpdateCustomerCard(
                            paramCustomerCardId,
                            customerId.value,
                            cardNumber.replace(/\s+/g, ""),
                            bankId,
                            cardVendorId,
                            expiredMonth,
                            expiredYear,
                            vcc,
                            mdr,
                            mdrQris,
                            mdrPl,
                            mdrPlQris,
                            dueDate,
                            billingDate,
                            cardLimit.replaceAll(',', '')
                        )
                        if (!res) return
                    }
                    
                    showSuccess({
                        onSuccess: () => {
                            navigate('/customer-card')
                        }
                    })
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await fetchDeleteCustomerCard(
                    paramCustomerCardId, status
                )
                if (!res) return
                
                showSuccess({
                    onSuccess: () => {
                        navigate('/customer-card')
                    }
                })
            } finally {
                hideLoading()
            }
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        if (customerId.value === EmptyString || customerId === EmptyString){
            errorCount++
            setErrorCustomerId(true)
        }else{
            setErrorCustomerId(false)
        }

        if (cardNumber === EmptyString){
            errorCount++
            setErrorCardNumber(true)
        }else{
            setErrorCardNumber(false)
        }

        if (bankId === EmptyString){
            errorCount++
            setErrorBankId(true)
        }else{
            setErrorBankId(false)
        }

        if (cardVendorId === EmptyString){
            errorCount++
            setErrorCardVendorId(true)
        }else{
            setErrorCardVendorId(false)
        }

        if (mdr === EmptyString){
            errorCount++
            setErrorMdr(true)
        }else{
            setErrorMdr(false)
        }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    const customerNameOnInput = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            // Get Customer
            fetchCustomerList(e, '', '', '1', 20, 0).then((res) => {
                if (!res) return

                let data = res.data.listData
                let arr = []

                arr.push({ label: "Pilih Pelanggan", value: "" })

                for (let i = 0; i < data.length; i++){
                    arr.push({ label: data[i].customerName.toUpperCase(), value: String(data[i].customerId) })
                }

                setCustomerOptions(arr)
            })
        }, 500) // delay here (ms)
    }

    useEffect(() => {
        const firstLoad = async () => {
            try {
                showLoading()

                // Get Bank
                const res = await fetchBankList('', '', '1', 10000, 0)

                if (!res) return

                let data = res.data.listData
                let tempArray = []

                tempArray.push({ label: "All", value: "" })

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
                }

                setBankOptions(tempArray)
                setBankId(tempArray[0].value)

                // Get Vendor
                const res2 = await fetchCardVendorList('', '1', 10000, 0)

                if (!res2) return

                let data2 = res2.data.listData
                let tempArray2 = []

                tempArray2.push({ label: "Pilih Vendor", value: "" })

                for (let i = 0; i < data2.length; i++){
                    tempArray2.push({ label: data2[i].cardVendorName, value: String(data2[i].cardVendorId) })
                }

                setCardVendorOptions(tempArray2)
                setCardVendorId(tempArray2[0].value)

                // Get Customer (If Form Type is Edit)
                if (formType ===  FormTypeEdit){
                    const res4 = await fetchCustomerCardById(paramCustomerCardId)

                    if (!res4) return

                    let data = res4.data

                    setCustomerId({label: data.customerName, value: String(data.customerId)})
                    setCardNumber(addSpaceEvery4(data.cardNumber))
                    setBankId(String(data.bankId))
                    setCardVendorId(String(data.cardVendorId))
                    setExpiredMonth(data.expiredMonth)
                    setExpiredYear(data.expiredYear)
                    setVcc(data.vcc)
                    setMdr(data.mdr)
                    setMdrQris(data.mdrQris)
                    setMdrPl(data.mdrPl)
                    setMdrPlQris(data.mdrPlQris)
                    setDueDate(data.dueDate)
                    setBillingDate(data.billingDate)
                    setCardLimit(money(data.cardLimit))
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                }
            } finally {
                hideLoading()
            }
            
        }

        firstLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Detail Kartu Pelanggan'
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="flex flex-col xl:flex-row gap-24">
                <div className="mt-5 flex flex-col gap-3">
                    <FormCard title='Pelanggan'>
                        <Select options={customerOptions} 
                            value={customerId} 
                            onInputChange={customerNameOnInput}
                            onChange={setCustomerId} 
                            placeholder={"Select Customer"} 
                            // isDisabled={formType === FormTypeEdit ? true : false} 
                        />
                    </FormCard>

                    <FormCard title='No Kartu'>
                        <input className="input" value={cardNumber} onChange={cardNumberChange} maxLength={19} />
                    </FormCard>

                    <FormCard title='Bank'>
                        <Select options={bankOptions} value={bankOptions.find(opt => opt.value === bankId)} onChange={bankIdChange} />
                    </FormCard>

                    <FormCard title='Card Vendor'>
                        <Select options={cardVendorOptions} value={cardVendorOptions.find(opt => opt.value === cardVendorId)} onChange={cardVendorIdChange} />
                    </FormCard>

                    <FormCard title='Expired'>
                        <div className="flex gap-4 w-full sm:w-72">
                            <input className="input" value={expiredMonth} onChange={expiredMonthChange} maxLength={2} />
                            <input className="input" value={expiredYear} onChange={expiredYearChange} maxLength={2} />
                        </div>                
                    </FormCard>

                    <FormCard title='VCC'>
                        <input className="input" value={vcc} onChange={vccChange} />
                    </FormCard>
                </div>
                <div className="mt-5 flex flex-col gap-3">
                    <FormCard title='MDR'>
                        <input className="input" value={mdr} onChange={mdrChange} maxLength={4} />
                    </FormCard>

                    <FormCard title='MDR QRIS'>
                        <input className="input" value={mdrQris} onChange={(e) => setMdrQris(decimal(e.target.value))} maxLength={4} />
                    </FormCard>

                    <FormCard title='MDR PL'>
                        <input className="input" value={mdrPl} onChange={(e) => setMdrPl(decimal(e.target.value))} maxLength={4} />
                    </FormCard>

                    <FormCard title='MDR PL Qris'>
                        <input className="input" value={mdrPlQris} onChange={(e) => setMdrPlQris(decimal(e.target.value))} maxLength={4} />
                    </FormCard>

                    <FormCard title='Tgl Cetak'>
                        <input className="input" value={billingDate} onChange={(e) => setBillingDate(decimal(e.target.value))} maxLength={2} />
                    </FormCard>

                    <FormCard title='Tgl Jatuh Tempo'>
                        <input className="input" value={dueDate} onChange={(e) => setDueDate(decimal(e.target.value))} maxLength={2} />
                    </FormCard>

                    <FormCard title='Limit Kartu'>
                        <input className="input" value={cardLimit} onChange={(e) => setCardLimit(money(e.target.value))} />
                    </FormCard>

                </div>
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </MainBodyCard>
    )
}